<!--
 * @Author: DY
 * @Date: 2021-01-27 14:43:47
 * @LastEditTime: 2021-01-29 18:15:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_test\src\views\jnApp\supplierPayable\supplierContract.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="supplierContract">
            <van-nav-bar
                title="合同详情"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <div class="title">
                {{ supplierName }}
            </div>
            <div class="btns">
                <template v-for="(item, index) in timeType">
                    <button
                        :class="{'active': selectType == index}"
                        @click="switchingTimeType(index)"
                        :key="index"
                    >
                        {{ item.name }}
                    </button>
                </template>
            </div>
            <div class="timeSlot" v-if="selectType == 2">
                <div class="startTime iconfont iconshijian" @click="openSelectTime('startTime', beginDate)">
                    <p>{{ beginDate }}</p>
                </div>
                <span>—</span>
                <div class="endTime iconfont iconshijian" @click="openSelectTime('endTime', endDate)">
                    <p>{{ endDate }}</p>
                </div>
            </div>
            <section
                v-if="contractListData.length > 0"
                :class="['van-pull-refresh', {'sectionHeight': selectType == 2}]"
            >
                <template v-for="(item, index) in contractListData">
                    <div class="contractList" :key="index" @click="openRawMaterial(item)">
                        <h3 class="iconfont icondanjubianhao">
                            合同名称：{{ item.contract_name }}
                        </h3>
                        <div class="money">
                            <div>
                                <p>{{ item.payable }}</p>
                                <span>累计应付(万元)</span>
                            </div>
                            <div>
                                <p>{{ item.actually_paid }}</p>
                                <span>累计实付(万元)</span>
                            </div>
                        </div>
                        <div class="money">
                            <div>
                                <p>{{ item.payable_balance }}</p>
                                <span>当前应付余额(万元)</span>
                            </div>
                            <div>
                                <p>{{ item.payable_rate }}</p>
                                <span>付款率</span>
                            </div>
                        </div>
                        <div class="contractData">
                            <p>合同编号：{{ item.contract_no }}</p>
                        </div>
                        <div class="contractData contractmateriel">
                            <h5>物料品种：{{ item.material_count }}</h5>
                        </div>
                    </div>
                </template>
            </section>
            <p v-else class="noData">
                暂无数据
            </p>
            <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
                <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    title="选择年月日"
                    :min-date="minDate"
                    @confirm="confirmDate"
                    @cancel="cancelDate"
                ></van-datetime-picker>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 合同详情
    name: 'supplier-contract',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/supplierPayable') {
            this.$store.commit('noKeepAlive', 'supplier-contract');
        }
        next();
    },
    data() {
        return {
            // 选择时间
            showCalendarPop: false,
            // 选择时间类型（开始时间，结束时间）
            selectTimeType: '',
            // 开始时间
            beginDate: '',
            // 结束时间
            endDate: '',
            // 选择时间控件默认时间
            currentDate: '',
            // 时间控件最小时间
            minDate: new Date(2000, 0, 1),
            // 时间类型
            timeType: [{
                name: '当前',
                val: 0,
            }, {
                name: '本年',
                val: 1,
            }, {
                name: '时间段',
                val: 2,
            }],
            // 选中时间类型
            selectType: null,
            // 供应商名称
            supplierName: '',
            // 合同列表数据
            contractListData: [],
        };
    },
    computed: {},
    watch: {
        selectType(newVal) {
            if (newVal === 0) {
                this.beginDate = '2000-01-01 00:00:00';
                const newToday = this.formatDate();
                this.endDate = newToday + ' 23:59:59';
                // 获取合同列表数据
                this.getContractListData();
            } else if (newVal === 1) {
                const nweYear = new Date().getFullYear();
                this.beginDate = nweYear + '-01-01 00:00:00';
                const newToday = this.formatDate();
                this.endDate = newToday + ' 23:59:59';
                // 获取合同列表数据
                this.getContractListData();
            }
        },
    },
    created() {
        this.supplierName = this.$route.params.supplierData.supplier_name;
        this.selectType = this.$route.params.selectType;
        this.beginDate = this.$route.params.beginDate;
        this.endDate = this.$route.params.endDate;
        if (this.$route.params.selectType === 2) {
            // 获取合同列表数据
            this.getContractListData();
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 打开选择时间
        openSelectTime(type, time) {
            this.currentDate = new Date(time);
            this.selectTimeType = type;
            this.showCalendarPop = true;
        },
        // 确认选择时间
        confirmDate(value) {
            if (this.selectTimeType === 'startTime') {
                const newDate = this.formatDate(value);
                this.beginDate = newDate + ' 00:00:00';
            } else if (this.selectTimeType === 'endTime') {
                const newDate = this.formatDate(value);
                this.endDate = newDate + ' 23:59:59';
            }
            this.showCalendarPop = false;
            // 获取合同列表数据
            this.getContractListData();
        },
        // 取消选择时间
        cancelDate() {
            this.showCalendarPop = false;
        },
        // 获取合同列表数据
        getContractListData() {
            this.$axios
                .get('/interfaceApi/report/statisticalanalysis/procurement/account/payable/contract?'
                    + `beginDate=${this.beginDate}`
                    + `&endDate=${this.endDate}`
                    + `&supplier_name=${this.$route.params.supplierData.supplier_name}`
                    + `&contract_no=${this.$route.params.supplierData.contract_no}`
                    + `&supplier_id=${this.$route.params.supplierData.supplier_id}`)
                .then(res => {
                    this.contractListData = res;
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 切换时间段类型
        switchingTimeType(index) {
            this.selectType = index;
        },
        // 打开原材料
        openRawMaterial(data) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'materialDetails',
                params: {
                    contractData: data,
                    selectType: this.selectType,
                    beginDate: this.beginDate,
                    endDate: this.endDate,
                },
            });
        },
        // 格式化日期
        formatDate(date) {
            if (date) {
                date = new Date(date);
            } else {
                date = new Date();
            }
            const Y = date.getFullYear();
            let M = date.getMonth() + 1;
            let D = date.getDate();
            M = M < 10 ? '0' + M : M;
            D = D < 10 ? '0' + D : D;
            return Y + '-' + M + '-' + D;
        },
    },
};
</script>
<style lang="stylus">
.supplierContract
    height 100%
    .title
        height 45rpx
        background #F3F9FF
        font-size 16rpx
        line-height 45rpx
        text-align center
        color #429CFB
    .timeSlot
        height 36rpx
        border 1px solid #D7D7D7
        border-radius 4rpx
        margin 0 15rpx 12rpx 15rpx
        box-shadow 2px 2px 8px rgba(84, 148, 243, 0.2)
        display flex
        >span
            width 24rpx
            line-height 32rpx
            color #D7D7D7
            text-align center
        >div
            width calc((100% - 24rpx)/2)
            padding-left 14rpx
            &:before
                color #979EA7
                line-height 32rpx
                font-size 14rpx
            p
                display inline-block
                color #061F3E
                font-size 12rpx
                padding-left 6rpx
    .btns
        display flex
        margin 15rpx
        button
            width 90rpx
            height 30rpx
            color #666666
            margin 0 15rpx
            font-size 14rpx
            border 1px solid #D7D7D7
            border-radius 4rpx
            background #fff
            box-shadow 2px 2px 8px rgba(84, 148, 243, 0.2)
            &.active
                color #fff
                border-color #0E84FF
                background #3495FB
                box-shadow 2px 2px 8px #5494F3
    section
        padding 0 15rpx
        height calc(100% - 150rpx)
        -webkit-overflow-scrolling touch
        overflow scroll
        &.sectionHeight
            height calc(100% - 198rpx)
        .contractList
            border-radius 4rpx
            margin-bottom 15rpx
            border 1px solid #D7D7D7
            box-shadow 2px 2px 8px rgba(84, 148, 243, 0.5)
            h3
                height 40rpx
                color #333333
                font-size 16rpx
                line-height 40rpx
                padding-left 15rpx
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
                background-color rgba(85, 136, 241, 0.06)
                &:before
                    font-size 18rpx
                    margin-right 5rpx
                    color #3495FB
            .money
                padding 10rpx
                display flex
                border-bottom 1px solid #F0F0F0
                p
                    color #666666
                    font-size 16rpx
                span
                    font-size 12rpx
                    color #979EA7
                div
                    flex 1
                    margin 0 15rpx
                    text-align center
                &:nth-of-type(2)
                    div

                        padding 3rpx 10rpx
                        background rgba(250, 132, 54, 0.06)
                        p
                            color #FF6600
                        span
                            color #666666
                        &:nth-of-type(2)
                            background rgba(52, 149, 251, 0.06)
                            p
                                color #3495FB
            .contractData
                padding-left 25rpx
                margin 8rpx 0 8rpx 15rpx
                background url(../../../../assets/images/icons/icon_gy_1.png) left center no-repeat
                background-size 16rpx
                h5
                    font-size 14rpx
                    color #419DFF
                    margin-bottom 7rpx
                    text-decoration underline
                p
                    font-size 14rpx
                    line-height 20rpx
                    color #666666
                &.contractmateriel
                    background url(../../../../assets/images/icons/icon_gy_3.png) left center no-repeat
                    background-size 16rpx
    .noData
        font-size 40rpx
        line-height 200rpx
        font-weight 600
        text-align center
        color #ccc
</style>
